{
  "blocks": [
    {
      "id": "proc-cryopreservation",
      "kind": "procedure",
      "tags": ["ivf", "egg-freezing", "storage", "lab", "both-partners"],
      "title": "Cryopreservation",
      "subtitle": "Freezing eggs, sperm, or embryos using vitrification for future use",
      "body": {
        "procedureName": "Cryopreservation",
        "category": "lab",
        "description": "Cryopreservation is the umbrella process used to preserve eggs, sperm, or embryos for future use. The exact freezing and thawing process depends on the specimen.",
        "howItWorks": "Modern vitrification (flash-freezing) rapidly cools cells to -196°C using liquid nitrogen, preventing ice crystal formation that could damage cells. Eggs, sperm, and embryos can be stored indefinitely. When needed, they're thawed quickly with survival rates above 95% for embryos and 85-90% for eggs. Specimens are stored in labeled straws within liquid nitrogen tanks at the clinic or a specialized storage facility.",
        "duration": "Immediate (the freezing itself takes minutes)",
        "costRange": {
          "low": 500,
          "high": 1500
        },
        "currency": "USD",
        "whatToExpect": [
          "Freezing happens automatically on the appropriate day",
          "No additional procedure for you, it happens in the lab",
          "Annual storage fees apply ($500-$1,000/year)",
          "Specimens can be shipped between facilities if needed",
          "Frozen embryos maintain their quality indefinitely"
        ],
        "forWhom": "both",
        "frBody": {
          "procedureName": "Cryoconservation",
          "description": "La cryoconservation est le processus général utilisé pour préserver des ovocytes, des spermatozoïdes ou des embryons en vue d'une utilisation ultérieure. Le processus exact de congélation et de décongélation dépend du type d'échantillon.",
          "howItWorks": "La vitrification moderne (congélation ultra-rapide) refroidit les cellules à -196 °C dans l'azote liquide, ce qui empêche la formation de cristaux susceptibles d'altérer les cellules. Les ovocytes, spermatozoïdes et embryons peuvent être conservés sans limite de durée. Au moment de l'utilisation, ils sont décongelés rapidement avec un taux de survie supérieur à 95 % pour les embryons et 85 à 90 % pour les ovocytes. Les échantillons sont conservés dans des paillettes étiquetées au sein de cuves d'azote liquide, à la clinique ou dans un centre de stockage spécialisé.",
          "duration": "Immédiat (la congélation elle-même prend quelques minutes)",
          "whatToExpect": [
            "La congélation est réalisée automatiquement au moment opportun",
            "Aucun geste supplémentaire pour vous, tout se passe au laboratoire",
            "Des frais annuels de stockage s'appliquent",
            "Les échantillons peuvent être transférés entre centres si nécessaire",
            "Les embryons congelés conservent leur qualité sur le long terme"
          ]
        }
      },
      "sources": [
        {
          "title": "Mature oocyte cryopreservation: a guideline",
          "authors": "Practice Committees of ASRM and SART",
          "journal": "Fertility and Sterility",
          "year": 2013,
          "url": "https://doi.org/10.1016/j.fertnstert.2012.09.028",
          "evidenceLevel": "guideline"
        },
        {
          "title": "Oocyte, embryo and blastocyst cryopreservation in ART: systematic review and meta-analysis comparing slow-freezing versus vitrification",
          "authors": "Rienzi L, Gracia C, Maggiulli R, et al.",
          "journal": "Human Reproduction Update",
          "year": 2017,
          "url": "https://academic.oup.com/humupd/article/23/2/139/2706961",
          "evidenceLevel": "meta-analysis"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
